<template>
    <section class="page-container-wide transition-up py-5" id="page">
        <div class="row">
            <div class="col-lg-8 col-xxl-9 relative ">
                <div class="d-flex transition-up-1 mb-3">
                    <h1 class="h2 m-0 fw-800">{{ $t('articles.h1') }}</h1>

                    <template v-if="$auth.user">
                        <dd-button
                            v-if="userCompanies.length"
                            class="btn-primary ml-auto"
                            id="add-case"
                            name="add-case"
                        >
                            {{ $t('general.add') }}
                            <span class="icon-ic-arrow-simple color-gray-3 ml-h dd-toggle-icon" />
                        </dd-button>

                        <dd-button
                            v-else-if="!canCreate"
                            class="btn-primary ml-auto"
                            name="add-menu"
                            anchor="article-add"
                            id="article-add"
                        >
                            {{ $t('general.add') }}
                        </dd-button>

                        <nuxt-link
                            v-else
                            class="btn-primary ml-auto"
                            id="add-case"
                            :to="localePath(`/editor/?type=article`)"
                        >
                            {{ $t('general.add') }}
                        </nuxt-link>
                    </template>
                    <panel-button
                        v-else
                        name="login"
                        @click.native="login"
                        class="btn-primary ml-auto"
                    >
                        {{ $t('general.add') }}
                    </panel-button>
                </div>

                <div class="filter-block d-flex transition-up-1 mx-n2 px-2">
                    <Search
                        v-model="search"
                        name="searchservice"
                        :placeholder="$t('cases.search')"
                        class="m-0 flex-grow-1 search"
                        @input="debounceFilter"
                        @change="debounceFilter"
                        ref="search"
                        size="2"
                    />

                    <dd-button
                        class="btn-bg sort-toggle ml-2 d-md-flex"
                        id="service-sort-toggle"
                        name="service-sort"
                    >
                        <span class="d-none d-lg-block">{{sorts[sortIndex].label}}</span>
                        <span class="d-lg-none">{{ $t('service.sort') }}</span>
                        <span class="icon-ic-arrow-simple color-gray-3 ml-h dd-toggle-icon" />
                    </dd-button>

                    <panel-button
                        class="btn-bg ml-2 d-none d-md-flex filter-button"
                        name="cases-filter"
                    >
                        <transition name="bubble-up">
                            <span  v-if="hasActiveFilter" class="chip-bage" />
                        </transition>

                        <span class="icon-ic-triangle mr-1 f-small color-gray-3" />
                        {{ $t('service.filters') }}
                    </panel-button>
                </div>

                <transition-group class="chips pt-2 transition-up-2" name="chips-transition" tag="div">
                    <Chip
                        class="colored blue" type="active"
                        v-for="chip in chips" :key="chip.id"
                        @close="chip.close"
                    >
                        <template v-slot:text>{{chip.label}}</template>
                    </Chip>
                </transition-group>

                <div class="segment-block d-flex transition-up-1 mt-3  mx-n2 px-2">
                    <div class="tab-list flex-grow-1">
                        <a
                            class="tab-item i-link"
                            href="/articles?segment=feed"
                            :class="{active: segment == 'feed'}"
                            @click.prevent="changeSegment('feed')"
                            v-if="$auth.user"
                        >
                            {{ $t('cases.forYou') }}
                        </a>

                        <a
                            href="/articles?segment=editorsChoice"
                            class="tab-item i-link"
                            :class="{active: segment == 'editorsChoice'}"
                            @click.prevent="changeSegment('editorsChoice')"
                        >
                            {{ $t('cases.editorsChoice') }}
                        </a>

                        <a
                            href="/articles?segment=all"
                            class="tab-item i-link"
                            :class="{active: segment == 'all'}"
                            @click.prevent="changeSegment('all')"
                        >
                            {{ $t('cases.all') }}
                        </a>
                    </div>

                    <nuxt-link
                        class="g-link ml-auto d-none d-md-block"
                        :to="localePath('/my/settings/interests')"
                    >
                        <span class="icon-ic-cog color-gray-3"/> {{ $t('cases.settings') }}
                    </nuxt-link>
                </div>


                <transition
                    :name="loadTransition"
                    mode="out-in"
                    @after-enter="cropContent"
                    @enter="cropContent"
                >
                    <transition-group
                        v-if="articlesLength"
                        :name="loadTransition"
                        :key="updatedAt"
                        class="row list mt-3 transition-up-2"
                        id="content-list"
                    >

                        <div
                            v-for="(post, i) in articles"
                            :key="`case-${post.id}`"
                            class="col-md-6 col-xxl-4 mt-2 mb-1"
                        >
                            <Article
                                class="h-100"
                                :article="post"
                                :toCases="true"
                                @removed="articles.splice(i, 1)"
                                @hidden="articles.splice(i, 1)"
                                @selectTopic="selectTopic"
                            />
                        </div>
                    </transition-group>

                    <Onboarding
                        class="mt-3 transition-up-3"
                        v-else-if="!articlesLength && segment == 'feed' && !chips.length"
                        page="articles"
                    />

                    <Card
                        v-else
                        :lower="true"
                        class="mt-3"
                    >
                        <p class="color-text">{{ $t('component.ListView.notFoundTitle') }}</p>

                        <p class="f-small color-muted my-1">{{ $t('component.ListView.tips') }}</p>
                        <ul class="f-small color-muted mt-h list-disk">
                            <li v-if="segment !== 'all'">
                                <a
                                    class="b-link"
                                    :href="localePath('/articles?segment=all')"
                                    @click.prevent="changeSegment('all')"
                                >
                                    {{ $t('component.ListView.tipSegment') }}
                                </a>
                            </li>
                            <li>{{ $t('component.ListView.tip1') }}</li>
                            <li>{{ $t('component.ListView.tip2') }}</li>
                            <li>{{ $t('component.ListView.tip3') }}</li>
                            <li>{{ $t('component.ListView.tip4') }}</li>
                            <li>
                                <dd-button
                                    class="b-link"
                                    name="locale-toggle"
                                    :anchor="$auth.user ? 'nav-user' : ['xs', 'sm'].includes($mq) ? 'nav-more' : 'locale-toggle'"
                                >
                                    {{ $t('component.ListView.tip5') }}
                                </dd-button>
                            </li>
                        </ul>
                    </Card>
                </transition>
                <Pagination
                    class="mt-3 transition-up-3"
                    :page="page"
                    :limit="limit"
                    :visibleLength="$mq == 'xs' ? 3 : 5"
                    :length="articlesLength"
                    :loading="paginationLoading"
                    :busy="paginationBusy"
                    @change="goToPage"
                    @load="loadPage"
                />
            </div>

            <!-- <div class="col-lg-1 d-xxl-none"></div> -->

            <div class="d-none d-lg-block col-lg-4 col-xxl-3 transition-up-3 pl-xxl-2">
                <div class="side-content mt-6 mt-lg-0">
                    <div class="mb-3">{{ $t('articles.popularTopics') }}</div>
                    <div class="d-flex m-nh flex-wrap ">
                        <button
                            v-for="topic in popularTags.slice(0, 5)"
                            :key="topic.id"
                            class="btn-tag m-h"
                            :class="{active: checkedTagsId.includes(topic.id)}"
                            @click="toggleTag(topic)"
                        >
                            {{topic.locales[locale]}}
                        </button>
                    </div>

                    <Banner class="my-4"/>

                    <div class="mt-6 mb-3">{{ $t('cases.popularAuthors') }}</div>
                    <PopularAuthors />
                </div>
            </div>
        </div>

        <div class="bottom-float d-md-none transition-up-4 mt-3">
            <panel-button
                class="btn-primary btn-lg filter-button"
                name="cases-filter"
            >
                <transition name="bubble-up">
                    <span  v-if="hasActiveFilter" class="chip-bage" />
                </transition>
                <span class="icon-ic-triangle mr-1 f-small color-gray-3" />
                {{ $t('service.filters') }}
            </panel-button>
        </div>

        <client-only>
            <dropdown
                v-if="userCompanies.length"
                anchor-id="add-case"
                modal-name="add-case"
                placement="bottom-end"
            >
                <div class="w-100 p-1">
                    <div class="tt-upper dd-header p-1 fw-700">
                        {{ $t('articles.addCaseVia') }}
                    </div>

                    <ul class="dd-list m-0">
                        <li>
                            <nuxt-link
                                class="menu-item iconed p-1 pr-2"
                                :to="localePath(`/editor/?type=article`)"
                            >
                                <div class="logo-small mr-1 rounded">
                                    <img
                                        :src="$auth.user.photo.avatar" alt=""
                                        width="24" height="24"
                                    >
                                </div>
                                {{ $auth.user.displayName }}
                            </nuxt-link>
                        </li>

                        <li
                            v-for="company in userCompanies"
                            :key="`add-cases-${company.id}`"
                        >
                            <nuxt-link
                                class="menu-item iconed p-1 pr-2"
                                :to="localePath(`/editor/?type=article&company=${company.id}`)"
                            >
                                <div class="logo-small mr-1">
                                    <img
                                        :src="company.logo" alt=""
                                        width="24" height="24"
                                    >
                                </div>
                                {{ company.name }}
                            </nuxt-link>
                        </li>
                    </ul>
                </div>
            </dropdown>

            <dropdown
                anchor-id="service-sort-toggle"
                modal-name="service-sort"
                placement="bottom-end"
            >
                <ul class="dd-list p-1">
                    <li
                        v-for="(sort, i) in sorts"
                        :key="`sort-${i}`"
                        :class="{selected: i == sortIndex}"
                    >
                        <button
                            @click="applySort(i)"
                            menu-item
                            class="menu-item iconed p-1 pr-2"
                        >
                            {{sort.label}}
                            <span
                                v-if="i == sortIndex"
                                class="icon-ic-tick-thin ml-auto dd-header"
                            />
                        </button>
                    </li>
                </ul>
            </dropdown>

            <panel
                modal-name="cases-filter"
                side="right"
                :defTitle="$t('service.filters')"
                :classes="['cases-filter-panel']"
            >
                <div class="filter-container d-flex flex-column" >
                    <div class="panel-container py-3">

                        <div class="d-none d-sm-block" v-if="$mq != 'xs'">
                            <CollapseButton
                                class="d-link fw-700 mb-2 filter-collapse-btn checkbox"
                                target="select-spec"
                            >
                                <div
                                    class="box elevate mr-1 global-ckeckbox"
                                    :class="{active: selectedTags.length}"
                                    @click.stop="clearSpec"
                                >
                                    <div class="tick"></div>
                                </div>
                                {{ $t('articles.topics') }}
                                <span class="icon-ic-arrow-simple color-gray-3 ml-1" />
                            </CollapseButton>

                            <collapse
                                :collapsed="false"
                                id="select-spec"
                                class="fade-effect"
                            >
                                <Search
                                    v-model="searchTags"
                                    :placeholder="$t('cases.search')"
                                    class="m-0 flex-grow-1 w-100 compact-search"
                                    size="10"
                                    @input="debounceTagFilter"
                                />

                                <Checkbox
                                    v-for="tag in tagsList"
                                    :key="`dt-spec-${tag.id}`"
                                    :value="checkedTagsId.includes(tag.id)"
                                    @change="toggleTag(tag)"
                                    class="my-2 align-items-center"
                                >
                                    <div class="d-flex">
                                        {{ tag.locales[locale] }}
                                        <span class="color-gray-2 ml-1">{{ tag.articlesLength }}</span>
                                    </div>
                                </Checkbox>
                            </collapse>
                        </div>


                        <div class="d-sm-none mb-11 align-items-center">
                            <div class="fw-700">{{ $t('articles.topics') }}</div>

                            <transition-group class="chips py-1 transition-up-2" name="chips-transition" tag="div">
                                <Chip
                                    class="colored blue" type="active"
                                    v-for="spec in selectedTags"
                                    :key="`smpc-${spec.id}`"
                                    @close="removeTag(spec)"
                                >
                                    <template v-slot:text>{{spec.locales[locale]}}</template>
                                </Chip>
                            </transition-group>

                            <dd-button
                                class="b-link w-100 fw-700 ta-left"
                                id="spec-sort-toggle"
                                name="cases-spec-filter"
                            >
                                {{ $t('cases.showAllTypes') }}
                            </dd-button>
                        </div>
                    </div>


                    <div class="panel-container filter-controls d-flex pt-2 mt-auto justify-content-center justify-content-md-start ">
                        <button
                            class="btn-bg elevate mr-3 tt-upper fw-600"
                            @click="clearFilter"
                        >
                            {{ $t('general.clear') }}
                        </button>

                        <button
                            class="btn-primary fw-600"
                            @click="$modalityStore.closeModal({
                                type: 'drawer',
                                name: 'cases-filter'
                            })"
                        >
                            {{ $t('general.applyChanges') }}
                        </button>
                    </div>
                </div>
            </panel>

            <dropdown
                anchor-id="spec-sort-toggle"
                modal-name="cases-spec-filter"
                placement="bottom-end"
            >
                <div
                    class="w-100 relative h-100"
                    v-if="$mq == 'xs'"
                >
                    <div class="d-flex sticky-search p-1">
                        <Search
                            v-model="searchTags"
                            name="searchType"
                            :placeholder="$t('cases.search')"
                            class="m-0 flex-grow-1 w-100"
                            ref="searchType"
                            size="10"
                            @input="debounceTagFilter"
                        />

                        <button
                            class="b-link ml-1"
                            @click="$modalityStore.closeDropdown({name: 'cases-spec-filter'});"
                        >
                            {{ $t('general.done') }}
                        </button>
                    </div>

                    <div class="pb-1 px-1 scroll-options">
                        <Checkbox
                            v-for="tag in tagsList"
                            :key="`dt-spec-${tag.id}`"
                            :value="checkedTagsId.includes(tag.id)"
                            @change="toggleTag(tag)"
                            class="my-2 align-items-center"
                        >
                            <div class="d-flex">
                                {{ tag.locales[locale] }}
                                <span class="color-gray-2 ml-1">{{ tag.articlesLength }}</span>
                            </div>
                        </Checkbox>
                    </div>
                </div>
            </dropdown>

        </client-only>
    </section>
</template>

<script>
import Chip      from '~/components/chips/Chip.vue'
import Card      from '~/components/cards/Card.vue';
import Search    from '~/components/form/SearchInputLow.vue';
import DdButton  from '~/components/DdButton.vue';
import PanelButton from '~/components/panels/PanelButton.vue';
import Article     from '~/components/thumbnails/ArticleThumbnail.vue';
import Pagination  from '~/components/Pagination.vue';
import PopularAuthors from '~/components/cases/PopularAuthors.vue';
import Onboarding     from '~/components/feed/FeedOnboarding.vue';
import Banner         from '~/components/promo/AsidePromo.vue';


const limit = 24;

import debounce    from '~/utilities/debounce.js';

export default {
    components: {
        Search,
        Checkbox: () => import('~/components/form/Checkbox.vue'),
        Dropdown: () => import('~/components/CasesDropdown.vue'),
        DdButton,
        Panel: () => import('~/components/panels/CasesPanel.vue'),
        PanelButton,
        Article,
        Chip,
        Pagination,
        Card,
        Collapse: () => import('~/components/collapse/Collapse.vue'),
        CollapseButton: () => import('~/components/collapse/Button.vue'),
        PopularAuthors,
        Onboarding,
        Banner
    },

    head () {
        const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true });

        return {
            title: this.$t('articles.title'),

            meta: [
                { hid: 'title',       name: "title",       content: this.$t('articles.title') },
                { hid: 'description', name: 'description', content: this.$t('articles.description') },

                { hid: "og:url",         property: "og:url",         content: `${process.env.baseUrl}/cases`},
                { hid: "og:title",       property: "og:title",       content: this.$t('articles.title')},
                { hid: "og:description", property: "og:description", content: this.$t('articles.description')},
                { hid: "og:image",       property: "og:image",       content: `${process.env.baseUrl}/images/CASES-OG.png`},

                { hid: "twitter:url",         name: "twitter:url"  ,       content: `${process.env.baseUrl}/cases`},
                { hid: "twitter:title",       name: "twitter:title",       content: this.$t('articles.title')},
                { hid: "twitter:description", name: "twitter:description", content: this.$t('articles.description')},
                { hid: "twitter:image",       name: "twitter:image",       content: `${process.env.baseUrl}/images/CASES-OG.png`}
            ],

            link: [
                ...i18nHead.link
            ]
        };
    },


    data () {
        return {
            search: this.$route.query.search,

            hasActiveFilter: false,
            searchSpec: '',
            articles: [],
            articlesLength: 0,

            popularTags: [],
            selectedTags: [],
            foundTags: null,
            tagsList: [],
            searchTags: '',


            page: 1,
            limit,
            paginationLoading: false,
            paginationBusy: false,

            updatedAt: new Date().getTime(),

            sortIndex: 0,
            sorts: [
                {
                    label: this.$t('companyPage.sortNewFirst'),
                    value: 'pubDate DESC'
                },
                {
                    label: this.$t('companyPage.sortPopular'),
                    value: 'views DESC'
                },
                {
                    label: this.$t('companyPage.sortLikes'),
                    value: 'likes DESC'
                },
                {
                    label: this.$t('companyPage.sortOldFirst'),
                    value: 'pubDate ASC'
                }
            ],


            segment: this.$auth.user ? 'feed' : 'editorsChoice',
            chips: []
        }
    },

    async asyncData({$axios, route, error, $auth, $appStore}) {
        $appStore.$patch({activeApp: 'media'})
        
        let params = {
            type: 'article',
            limit,
            sort: 'pubDate DESC'
        }

        let segment = 'all';

        let page = parseInt(route.query.page)
        if (page >= 2) params.skip = (page - 1) * limit;

        if (route.query.search) params.search = route.query.search;
        if (route.query.sort)   params.sort = route.query.sort;



        if (
            (!route.query.segment && !$auth.user) ||
            (route.query.segment && route.query.segment.toLowerCase() == 'editorschoice')
        ) {
            params.editorsChoice = true;
            segment = 'editorsChoice';
        }


        if (
            $auth.user &&
            (!route.query.segment || route.query.segment.toLowerCase() == 'feed')
        ) {
            params.personalized = 1;
            segment = 'feed';
        }


        let postData, popTagData, filterTagData;
        let promise = [
            $axios.$get(`${$axios.defaults.baseURL}/publication/find`, {
                params
            }),
            $axios.$get(`/tag/find`, {
                params: {
                    confirmed: true,
                    sort: 'articlesLength DESC',
                    limit: 30
                },
                progress: false
            })
        ];


        if (route.query.topic) {
            params.topic = route.query.topic;

            if (!Array.isArray(params.topic)) {
                params.topic = [params.topic];
            }

            promise.push(
                $axios.$get(`/tag/find`, {
                    params: {
                        id: params.topic
                    },
                    progress: false
                })
            )
        }


        await Promise.all(promise)
        .then(res => {
            [postData, popTagData, filterTagData] = res;
        })
        .catch((e) => {
            error({ statusCode: 404, message: '' })
        });

        if (!postData) return;


        let result = {
            segment,
            articles: postData.posts,
            articlesLength: postData.length,
            popularTags: popTagData.tags
        }

        if (page) result.page = page;
        if (filterTagData) result.selectedTags = filterTagData.tags;


        return result;
    },

    computed: {
        locale () {
            return this.$i18n.locale;
        },

        checkedTagsId () {
            return this.selectedTags.map(o => o.id);
        },

        userCompanies () {
            if (
                !this.$auth.user ||
                !this.$auth.user.moders ||
                this.$auth.user.role.en == 'Newbie'
            ) {
                return [];
            }

            return this.$auth.user.moders.map(o => o.company);
        },

        query () {
            let query = {
                type: 'article',
                limit,
                skip: (this.page -1) * this.limit,
                sort: this.sorts[this.sortIndex].value
            };

            if (this.search) query.search = this.search;
            if (this.segment == 'editorsChoice') query.editorsChoice = true;
            if (this.segment == 'feed') query.personalized = 1;

            if (this.checkedTagsId && this.checkedTagsId.length) {
                query.tags = this.checkedTagsId
            }

            return query;
        },

        loadTransition () {
            return this.paginationLoading ? 'none' : 'fade-slide-top'
        },

        canCreate (){
            return this.$auth.user && this.$auth.user.role.name.en != 'Newbie';
        }
    },

    watch: {
        page (newVal) {
            this.newRouteQueryCache();

            if (newVal <= 1 && this.routeQueryCache) {
                delete this.routeQueryCache.page;
            } else {
                this.routeQueryCache.page = newVal;
            }

            this.debounceUrl();
        },

        search (newVal) {
            this.newRouteQueryCache();

            if (newVal === '' && this.routeQueryCache.search) {
                delete this.routeQueryCache.search;
            } else {
                this.routeQueryCache.search = newVal;
            }

            this.debounceUrl();
        },

        checkedTagsId (newVal) {
            if (JSON.stringify(this.$route.query.topic) === JSON.stringify(newVal)) {
                return;
            }

            this.newRouteQueryCache();

            if ((!newVal || !newVal.length) && this.routeQueryCache.topic) {
                delete this.routeQueryCache.topic;
            } else {
                this.routeQueryCache.topic = newVal;
            }

            this.debounceUrl();
        },


        segment (newVal) {
            this.newRouteQueryCache();

            if (
                (
                    (this.$auth.user && newVal == 'feed') ||
                    (!this.$auth.user && newVal == 'editorsChoice')
                ) && this.routeQueryCache.segment
            ) {
                delete this.routeQueryCache.segment;
            } else {
                this.routeQueryCache.segment = newVal;
            }

            this.debounceUrl();
        },

        '$route.query.search': function (value) {
            this.search = value;
        }
    },

    created () {
        this.updateChips();

        if (this.$route.query.sort) {
            this.sortIndex = this.sorts.findIndex(o => {
                return this.$route.query.sort == o.value;
            })
        }
    },

    mounted () {
        window.addEventListener('keydown', this.shortCuts);
        this.updateTagsList();
    },

    methods: {
        newRouteQueryCache () {
            if (!this.routeQueryCache) {
                this.routeQueryCache = Object.assign({}, this.$route.query);
            }
        },

        debounceUrl: debounce(function () {
            this.updateUrl();
        }, 100),

        updateUrl () {
            if (Object.keys(this.routeQueryCache).length === 0) {
                this.$router.replace({query: null});
            } else {
                this.$router.replace({query: this.routeQueryCache});
            }

            this.routeQueryCache = null;
        },


        changeSegment (name) {
            this.segment = name;
            this.applyFilter();
        },

        toggleTag (tag) {
            let tagIndex = this.selectedTags.findIndex(o => tag.id == o.id);
            if (tagIndex < 0) this.selectedTags.push(tag)
            else this.selectedTags.splice(tagIndex, 1);

            this.debounceFilter();
        },

        selectTopic (payload) {
            this.selectedTags = [payload.tag];
            this.debounceFilter();

            this.$scrollTo(`#page`, {
                offset: -80
            });
        },

        cropContent () {
            this.$cropContent()
        },

        sortSpec (arr) {
            let locale = this.$i18n.locale;

            arr.sort(function(a, b) {
                return ('' + a.locales[locale]).localeCompare(b.locales[locale], locale);
            });

            return arr;
        },

        updateTagsList () {
            let tags = this.foundTags;
            if (!this.foundTags) {
                tags = this.arrayUnique([...this.popularTags, ...this.selectedTags]);
            }

            this.tagsList = this.sortSpec(tags);
        },

        arrayUnique (array) {
            let a = array.concat();
            for (let i = 0; i < a.length; ++i) {
                for (let j = i+1; j < a.length; ++j) {
                    if (a[i].id === a[j].id) a.splice(j--, 1);
                }
            }
            return a;
        },

        clearSpec () {
            this.selectedTags = [];
            this.applyFilter();
        },

        removeTag (tag) {
            let tagIndex = this.selectedTags.findIndex(o => tag.id == o.id);
            if (tagIndex >= 0) this.selectedTags.splice(tagIndex, 1);

            this.applyFilter();
        },

        debounceTagFilter: debounce(function () {
            this.findTags();
        }, 300),

        async findTags () {
            if (this.searchTags) {
                let data = await this.$axios.$get('/tag/find', {
                    params: {
                        search: this.searchTags,
                        limit: 30,
                        confirmed: true
                    }
                });

                this.foundTags = data.tags;
            } else {
                this.foundTags = null;
            }

            this.updateTagsList()
        },





        clearFilter () {
            this.selectedTags = [];
            this.search = '';

            this.applyFilter();
        },

        debounceFilter: debounce(function () {
            this.applyFilter();
        }, 300),

        async goToPage (page) {
            this.page = page;
            let data = await this.load();

            let done = () => {
                this.updatedAt = new Date().getTime();

                this.articles = data.posts;
                this.articlesLength = data.length;
            }

            this.$scrollTo(`#page`, {
                offset: -80,
                onDone: () => {done()},
                onCancel: () => {done()}
            });
        },

        async loadPage () {
            this.paginationLoading = true;
            this.page++;
            let data = await this.load();

            this.articles.push(...data.posts);
            this.articlesLength = data.length;
            this.paginationLoading = false;
        },

        async load () {
            this.paginationBusy = true;

            let data = await this.$axios.$get('/publication/find', {
                params: this.query
            });

            this.updateChips();
            this.paginationBusy = false;

            return data;
        },

        applySort (index) {
            if (this.sortIndex == index) return;

            this.sortIndex = index;
            this.$modalityStore.closeDropdown({name: 'service-sort'});



            this.newRouteQueryCache();

            if (index == 0 && this.routeQueryCache.sort) {
                delete this.routeQueryCache.sort;
            } else {
                this.routeQueryCache.sort = this.sorts[index].value;
            }

            this.debounceUrl();
            this.applyFilter();
        },

        async applyFilter () {
            this.page = 1;

            let data = await this.load();

            // this.updateChips();
            this.updatedAt = new Date().getTime();

            this.articles = data.posts;
            this.articlesLength = data.length;

            if (this.search) this.$gtag('event', 'search', {'search_term': this.search})
        },

        updateChips () {
            let chips = [];
            let vm = this;

            if (this.selectedTags) {
                this.selectedTags.forEach(tag => {
                    chips.push({
                        label: `${this.$t('articles.topic')}: ${tag.locales[this.locale]}`,
                        id: `chiptag${tag.id}`,
                        close () {
                            vm.removeTag(tag);
                        }
                    })
                })
            }

            if (this.search) {
                chips.push({
                    label: this.search,
                    id: 'search',
                    close () {
                        vm.search = '';
                        vm.applyFilter();
                    }
                })
            }

            this.chips = chips;
        },

        shortCuts (e) {
            let inputs = ['INPUT', 'TEXTAREA'];
            if (inputs.indexOf(e.target.tagName.toUpperCase()) >= 0) return true;

            // focus search
            if (e.keyCode === 191) {
                e.preventDefault();
                this.$refs.search.focus();
            }
        },

        focus (name) {
            setTimeout(() => {
                this.$refs[name].focus();
            }, 150)
        }
    },

    destroyed () {
        window.removeEventListener('keydown', this.shortCuts)
    },
}
</script>

<style lang="postcss" scoped>

    .side-content {
        /* max-width: 560px; */

        max-width: 288px;
        margin-left: auto;
    }

    .sort-toggle {
        border-radius: 8px;
        padding: 8px;

        @media (min-width: 992px) {
            min-width: 170px;
        }

        .icon-ic-arrow-simple {
            transform: rotate(0deg);
            transition: transform .25s ease;
        }

        &.active {
            .icon-ic-arrow-simple {
                transform: rotate(180deg);
            }
        }
    }

    .filter-container {
        position: relative;
        height: 100%;
        flex-grow: 2;
    }

    .filter-controls {
        position: sticky;
        -webkit-position: sticky;
        bottom: 0;
        border-top: 1px solid var(--color-cases-gray-4);
        padding-bottom: calc(16px + env(safe-area-inset-bottom));
        background-color: var(--color-layer-3);
    }


    .filter-star {
        font-size: 19px;
        color: transparent;
        -webkit-text-stroke-width: 1px;
        -webkit-text-stroke-color: var(--color-cases-gray-0);

        transition: color .1s ease,
                    -webkit-text-stroke-color .1s ease;
    }

    input:checked + .filter-star {
        color: var(--color-cases-cadmium-yellow);
        -webkit-text-stroke-color: var(--color-cases-cadmium-yellow);
    }

    .control-prefix {
        min-width: 34px;
    }

    .filter-button {
        position: relative;

        .chip-bage {
            top: 10px;
            right: 10px;

            width: 8px;
            height: 8px;
        }
    }

    .bottom-float {
        position: sticky;
        -webkit-position: sticky;

        display: flex;
        align-items: center;
        justify-content: center;

        padding: 16px 0;
        pointer-events: none;

        bottom:   calc(48px + env(safe-area-inset-bottom));

        @media screen and (min-width: 768px) {
            bottom: calc(env(safe-area-inset-bottom));
        }


        .btn-primary {
            pointer-events: all;
        }
    }


    .scroll-options {
        min-height: calc(100vh - 160px);
    }

    .sticky-search {
        position: sticky;
        -webkit-position: sticky;
        top: 0;
        background-color: var(--color-layer-3);
    }


    .filter-collapse-btn {
        display: flex;
        align-items: center;

        .icon-ic-arrow-simple {
            transform: rotate(180deg);
            transition: transform .3s ease;
        }

        &.collapsed {
            .icon-ic-arrow-simple {
                transform: rotate(0deg);
            }
        }
    }

    .logo-small {
        width: 24px;
        height: 24px;
        display: block;
        border-radius: 4px;
        overflow: hidden;
        box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.04),
                    0px 1px 2px rgba(0, 0, 0, 0.16);
    }
</style>
